import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

const LoginDescriptionComponent = () => {
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];
      if (rapsResult) {
        setDescription(rapsResult.description);
      }
    }
  }, [RapsEuropeData]);
  
  return (
    <>
      <div className="col-md-12" dangerouslySetInnerHTML={{ __html: description }}></div>
    </>
  );
};

export default LoginDescriptionComponent;
